import React from 'react';
import cn from 'classnames';
import isBoolean from 'lodash/isBoolean';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';

import styles from '../styles.scss';
import IconDescription from '@dealroadshow/uikit/core/components/Icon/IconDescription';
import IconMinus from '@dealroadshow/uikit/core/components/Icon/IconMinus';
import IconCheck from '@dealroadshow/uikit/core/components/Icon/IconCheck';

interface IProps {
  cellData: boolean | string | React.ReactElement,
}

const CheckCell = ({ cellData }: IProps) => {
  if (isBoolean(cellData)) {
    const IconComponent = cellData ? IconCheck : IconMinus;

    return (
      <IconComponent
        className={ cn({
          [styles.iconCheckCell]: cellData,
          [styles.iconUnCheckCell]: !cellData,
        }) }
      />
    );
  }

  return (
    <div>
      <Tooltip content={ cellData }>
        <IconDescription className={ styles.iconDescriptionCell } />
      </Tooltip>
      <span className={ styles.descriptionCell }>{ cellData }</span>
    </div>
  );
};

export default CheckCell;
